/* Galerie d'images */
$( document ).ready(function() {
    var $galleryCounter = $('.column-right__img-gallery img:first').attr('data-attribute-counter');
    $('.column-right__gallery-counter span').text($galleryCounter);
});

$('.column-right__gallery-counter .next-image').click(function(e) {
    e.preventDefault();
    var $gallery = $(this).parent('.column-right__gallery-counter').prev('.column-right__img-gallery');
    var $firstImg = $('.column-right__img-gallery img:first');
    var $nextImg = $firstImg.next();
    var $number = $nextImg.attr('data-attribute-counter');
    var $counter = $('.column-right__gallery-counter span');
    $firstImg.appendTo($gallery);
    $counter.text($number);
});
